import { render, staticRenderFns } from "./exponentPieChart.vue?vue&type=template&id=175d6f04"
import script from "./exponentPieChart.vue?vue&type=script&lang=js"
export * from "./exponentPieChart.vue?vue&type=script&lang=js"
import style0 from "./exponentPieChart.vue?vue&type=style&index=0&id=175d6f04&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports